<script>
/*
 * This component extends the ChartJS Line and provides the
 * custom options and takes a prop with the actual chart data.
 */

/* eslint-disable no-unused-vars */
import { Bar } from "vue-chartjs";
import { chartDefaults, TooltipLine } from "../../../utilities";

export default {
	extends: Bar,
	props: {
		chartData: Object,
		chartHeight: String,
		chartAriaLabel: {
			type: String,
			default: "Bar chart"
		},
		timeUnit: String,
		yScaleTitle: String,
		/**
		 * "rebuild" -  the chart "updates" via chart.destroy then this.renderChart
		 * "off" - turn animations off completely
		 * defaults to the standard ChartJS animation when you call chart.update()
		 */
		animationType: String
	},
	data: function () {
		return {
			options: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				},
				tooltips: {
					enabled: false,
					intersect: false,
					mode: "index"
				},
				scales: {
					xAxes: [
						{
							gridLines: {
								display: false,
								drawBorder: false,
								lineWidth: 2
							},
							ticks: {
								fontColor: "white", // Instead of display: false because that allows chart to use more width than line chart
								autoSkip: true,
								maxRotation: 0,
								padding: 8
							},
							type: "time",
							time: {
								unit: this.timeUnit,
								round: "day",
								stepSize: 1,
								displayFormats: {
									month: "MMM [']YY"
								}
							}
						}
					],
					yAxes: [
						{
							scaleLabel: {
								display: this.yScaleTitle ? true : false,
								labelString: this.yScaleTitle
							},
							gridLines: {
								display: true,
								drawBorder: false
							},
							ticks: {
								maxTicksLimit: 4,
								padding: 30,
								beginAtZero: false
							},
							// Delete highest tick on y-axis
							afterBuildTicks: function (chart) {
								chart.ticks = chart.ticks.slice(1);
							},
							afterFit: function (scaleInstance) {
								scaleInstance.width = 100; // To sync Y axis width
							}
						}
					]
				},
				hover: {
					mode: "index",
					intersect: false,
					onHover: (e) => {
						// Emit an event to the parent to handle what to do on mouse out
						if (e.type === "mouseout") {
							this.$emit("chartMouseOut");
						}
						// Don't do anything if this is from synced simulation
						else if (e.type === "click") {
							return;

							// Send an event to parent to tell it that the index changed
						} else if (
							this.$data._chart.tooltip._active &&
							this.$data._chart.tooltip._active.length
						) {
							if (
								this.$data._chart.tooltip._active[0]._index !== this.activeIndex
							) {
								this.activeIndex = this.$data._chart.tooltip._active[0]._index;
								this.$emit("activeIndexChanged", this.activeIndex);
							}
						}
					}
				}
			},
			activeIndex: 0
		};
	},
	watch: {
		chartHeight: function () {
			this.setHeight(this.chartHeight);
		}
	},
	mounted() {
		this.addPlugin(TooltipLine);
		this.renderChart(this.chartData, this.options);

		// Adds a class to the generated container
		this.$data._chart.canvas.parentNode.classList.add("bar-chart");
		this.$data._chart.canvas.setAttribute("role", "img");
		this.$data._chart.canvas.setAttribute("aria-label", this.chartAriaLabel);
	},
	methods: {
		/* Called when the data changes */
		update() {
			if (this.animationType === "rebuild") {
				this.$data._chart.destroy();
				this.renderChart(this.chartData, this.options);
				return;
			}
			if (this.animationType === "off") {
				this.$data._chart.update({ duration: 0 });
				return;
			}
			this.$data._chart.update();
		},
		/* Sets the height of chart on load and breakpoint change */
		setHeight(newHeight) {
			this.$data._chart.canvas.parentNode.style.height = newHeight;
		}
	}
};
</script>
